$(document).ready(function () {
	"use strict";

	AOS.init();
	$(window).scroll(function () {
		if ($(window).scrollTop() > 700) {
			$("#btn-top").addClass("active");
		} else {
			$("#btn-top").removeClass("active");
		}
	});

	var headerHight = $(".main-header").height();

	function calculateHeaderValues() {
		document
			.querySelector(":root")
			.style.setProperty("--menuHeight", `${headerHight}px`);
	}
	calculateHeaderValues();

	$(window).on("resize", function () {
		headerHight = $(".main-header").height();
		calculateHeaderValues();
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > headerHight) {
			$(".main-header").addClass("sticky-navbar");
			$(".logo").addClass("active-sticky");
			$(".menu-item").addClass("active-sticky");
			$(".menu-text").addClass("active-sticky");
			$(".menu-border").addClass("active-sticky");
		} else if ($(window).scrollTop() <= 0) {
			$(".main-header").removeClass("sticky-navbar");
			$(".logo").removeClass("active-sticky");
			$(".menu-item").removeClass("active-sticky");
			$(".menu-border").addClass("active-sticky");
		}
	});

	var headerHight1 = $(".main-header1").height();

	function calculateHeaderValues1() {
		document
			.querySelector(":root")
			.style.setProperty("--menuHeight", `${headerHight1}px`);
	}
	calculateHeaderValues1();

	$(window).on("resize", function () {
		headerHight1 = $(".main-header1").height();
		calculateHeaderValues1();
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > headerHight1) {
			$(".main-header1").addClass("sticky-navbar1");
			$(".logo").addClass("active-sticky1");
			$(".menu-item").addClass("active-sticky1");
			// $("#mobile-menu-toggle").addClass("active-sticky1")
		} else if ($(window).scrollTop() <= 0) {
			$(".main-header1").removeClass("sticky-navbar1");
			$(".logo").removeClass("active-sticky1");
			$(".menu-item").removeClass("active-sticky1");
			$("#mobile-menu-toggle").removeClass("active-sticky1");
		}
	});

	var menuItems = $("#main-menu").html();
	var mobileMenu = $(".mobile-menu-inner");
	mobileMenu.html(menuItems);

	$("#mobile-menu-toggle").click(function () {
		$(".mobile-menu-container").addClass("active");
	});

	$(".close-mobile-menu").click(function () {
		$(".mobile-menu-container").removeClass("active");
	});

	$(".mobile-menu-inner").on("click", ".inner-menu-toggle", function () {
		$(this).parent().children(".inner-menu-list").slideToggle();
		$(this).parent().children(".inner-menu-list-2").slideToggle();
		$(this).parent().parent().children(".inner-menu-list").slideToggle();
		$(this).parent().parent().children(".inner-menu-list-2").slideToggle();
		$(this).parent().toggleClass("active");

		console.log($(this).parent());
	});

	$("#faq-group-1 .item-btn").click(function () {
		var value = $(this).val();
		console.log(value);

		$("#faq-group-1 .item-btn").not(this).removeClass("active");

		$(this).toggleClass("active");

		$("#faq-group-1 .item-content").each(function () {
			if (value == $(this).attr("id")) {
				$("#faq-group-1 .item-content.active").not(this).slideToggle("medium");
				$("#faq-group-1 .item-content").not(this).removeClass("active");
				$(this).slideToggle("medium");
				$(this).toggleClass("active");
			}
		});
	});

	var proQty = $(".pro-qty");
	$(".qty-btn").on("click", function (e) {
		e.preventDefault();
		var $button = $(this);
		var oldValue = $button.parent().find("input").val();
		if ($button.hasClass("inc")) {
			var newVal = parseFloat(oldValue) + 1;
		} else {
			// Don't allow decrementing below zero
			if (oldValue > 1) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 1;
			}
		}
		$button.parent().find("input").val(newVal);
	});

	$(".testimonials").owlCarousel({
		loop: true,
		nav: false,
		autoplay: true,
		dots: false,
		autoplayTimeout: 4000,
		item: 3,
		margin: 20,
		smartSpeed: 500,
		dotsEach: true,
		navContainer: ".testimonials-nav",
		navText: [
			`<div class="h-10 w-10 flex items-center justify-center shadow-lg rounded-xl bg-white hover:bg-red-600 transition-all ease-in-out duration-300 group/testimonial ">
      <i class="fa-solid fa-chevron-left text-xl text-secondary "></i>
      </div>
        `,
			`<div class="h-10 w-10 flex items-center justify-center shadow-lg rounded-xl bg-white hover:bg-red-600 transition-all ease-in-out duration-300 group/testimonial">
      <i class="fa-solid fa-chevron-right text-xl text-secondary "></i>
      </div>
        `,
		],
		responsive: {
			0: {
				items: 1,
				autoplay: false,
			},
			767: {
				items: 1,
				center: false,
				autoplay: false,
			},
			1023: {
				items: 2,
				center: false,
			},
			1279: {
				items: 2,
				center: false,
			},
			1535: {
				items: 2,
				center: false,
			},
		},
	});

	$(".product-slider").owlCarousel({
		loop: true,
		nav: false,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplaySpeed: 500,
		items: 1,
		margin: 100,
		dotsEach: true,
		dots: true,
		dotsContainer: "#custom-dots-container",
	});

	var verticalSwiper = new Swiper(".product-vertical-slider", {
		// direction: "vertical",
		autoplay: true,
		slidesPerView: 4,
		freeMode: true,
		loopedSlides: 4,
		loop: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		spaceBetween: 10,
		breakpoints: {
			0: {
				direction: "horizontal",
			},
			640: {
				direction: "vertical",
			},
		},
	});

	var productSwiper = new Swiper(".single-product-slider", {
		loop: true,
		slidesPerView: 1,
		autoplay: true,
		navigation: false,
		// reverseDirection: true,
		thumbs: {
			swiper: verticalSwiper,
		},
	});
	var famousPeopleSwiper = new Swiper(".famous-people-slider", {
		loop: true,
		slidesPerView: 4,
		autoplay: true,

		spaceBetween: 20,
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			767: {
				slidesPerView: 2,
			},
			1023: {
				slidesPerView: 3,
			},
			1279: {
				slidesPerView: 4,
			},
			1535: {
				slidesPerView: 4,
			},
		},
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > 700) {
			$("#btn-top").addClass("active");
		} else {
			$("#btn-top").removeClass("active");
		}
	});

	$("#btn-top").click(function () {
		window.scrollTo(0, 0);
	});

	$(window).on("load", function () {
		$("#preloader").removeClass("active");
	});

	AOS.init();
});

let dateOfBirthList = document.querySelectorAll(".dateOfBirth");

dateOfBirthList.forEach((element) => {
	let theDate = element.getAttribute("data-value");
	const targetDate = new Date(theDate);
	const currentDate = new Date();
	const timeDifference = currentDate - targetDate;

	const years = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 365.25));
	const weeks = Math.floor(
		(timeDifference % (1000 * 60 * 60 * 24 * 365.25)) /
			(1000 * 60 * 60 * 24 * 7),
	);
	const remainingDays = Math.floor(
		(timeDifference % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24),
	);

	const printDate = document.createElement("p");
	printDate.classList.add(
		"text-lg",
		"text-primary",
		"font-normal",
		"capitalize",
	);

	if (years > 0) {
		printDate.textContent = `${years} years ${weeks} weeks ${remainingDays} days old`;
	} else {
		printDate.textContent = `${weeks} weeks ${remainingDays} days old`;
	}

	element.appendChild(printDate);
});
